import { createReducer } from '@reduxjs/toolkit';
import { getBlogPage } from '../actions/blogPage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getBlogPage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
